import { useState } from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { TrustMarquee } from "@/components/TrustMarquee";
import { Services } from "@/components/Services";
import { Pricing } from "@/components/Pricing";
import { WhyUs } from "@/components/WhyUs";
import { Process } from "@/components/Process";
import { About } from "@/components/About";
import { Testimonials } from "@/components/Testimonials";
import { Gallery } from "@/components/Gallery";
import { Faq } from "@/components/Faq";
import { FinalCta } from "@/components/FinalCta";
import { Footer } from "@/components/Footer";
import { BookingDialog } from "@/components/BookingDialog";

export default function Landing() {
  const [booking, setBooking] = useState({ open: false, service: null });
  const openBooking = (service = null) => setBooking({ open: true, service });

  return (
    <div className="bg-ink font-body text-white">
      <Navbar onBook={() => openBooking()} />
      <main>
        <Hero onBook={() => openBooking()} />
        <TrustMarquee />
        <Services onBook={openBooking} />
        <Pricing onBook={openBooking} />
        <WhyUs />
        <Process />
        <About onBook={openBooking} />
        <Testimonials />
        <Gallery />
        <Faq />
        <FinalCta onBook={() => openBooking()} />
      </main>
      <Footer />
      <BookingDialog
        open={booking.open}
        onOpenChange={(o) => setBooking((b) => ({ ...b, open: o }))}
        presetService={booking.service}
      />
    </div>
  );
}
